import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(Box)`
  &.MuiBox-root {
    display: flex;
    align-items: center;
    flex-direction: column;

    height: calc(97vh);
    padding-top: 80px;
  }
`;
